export interface ProjetCreationWorkflow {
    Code?: string,
    Libelle?: string,
    Ordre?: number,
    IsStepChronoDisplayed?: boolean
}

const INFORMATIONS_GENERALES: string = "INF"
const DESCRIPTION: string = "DES"
const FINANCEMENT_PARTICIPATIF: string = "FIP"
const CAGNOTTE: string = "CAG"
const FINANCEMENT_GLOBAL: string = "FIG"
const FINALISATION: string = "FIN"

export const ProjetCreationWorkflow = {
    INFORMATIONS_GENERALES,
    DESCRIPTION,
    FINANCEMENT_PARTICIPATIF,
    CAGNOTTE,
    FINANCEMENT_GLOBAL,
    FINALISATION
}